// src/utils/eventDateUtils.js

import { parseDate } from './formatters';

/**
 * Verifica se as vendas ainda não começaram.
 * Como sales_start_at chega em UTC da API, parseDate(sales_start_at) 
 * representará o instante exato em que as vendas devem começar em UTC,
 * que é comparado corretamente com o tempo local atual.
 */
export function checkIsSalesNotStarted(event) {
  if (!event?.sales_start_at) return false;
  
  const salesStartDate = parseDate(event.sales_start_at);
  const currentTime = new Date();
  
  return currentTime < salesStartDate;
}

/**
 * Verifica se o evento já aconteceu/encerrou.
 */
export function checkIsEventEnded(event) {
  if (!event) return false;
  if (event.sale_status === 'CLOSED') return true;

  const referenceDate = event.end_date || event.start_date || event.date;
  if (!referenceDate) return false;

  const endDate = parseDate(referenceDate);

  // Se não houver data de término explícita (apenas data ou start_date),
  // o evento encerra às 02:00 BRT (05:00 UTC) do dia seguinte.
  if (!event.end_date) {
    endDate.setUTCDate(endDate.getUTCDate() + 1);
    endDate.setUTCHours(5, 0, 0, 0);
  }

  return new Date() > endDate;
}

/**
 * Verifica se as as vendas já encerraram.
 */
export function checkIsSalesEnded(event) {
  if (event?.sales_end_at) {
    const salesEndDate = parseDate(event.sales_end_at);
    return new Date() > salesEndDate;
  }

  // Fallback se não houver sales_end_at definido explicitamente
  if (event?.date) {
    const eventDate = parseDate(event.date);
    // Por padrão, se não houver data de fim de venda, 
    // encerra as vendas no dia seguinte ao evento às 02:00 local
    const fallbackEndDate = new Date(eventDate);
    fallbackEndDate.setDate(fallbackEndDate.getDate() + 1);
    fallbackEndDate.setHours(2, 0, 0, 0);
    
    return new Date() > fallbackEndDate;
  }

  if (event?.end_date) {
    const eventEndDate = parseDate(event.end_date);
    // Encerra no dia do fim do evento às 02:00 local
    const fallbackEndDate = new Date(eventEndDate);
    fallbackEndDate.setHours(2, 0, 0, 0);
    
    return new Date() > fallbackEndDate;
  }

  return false;
}
